










import { Component, Vue } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";

@Component({
  name: "grid-flag-component",
  components: { AgGridVue },
})
export default class GridFlagComponent extends Vue {
  value: string;

  beforeMount() {
    this.value = this.$data.params.value;
  }
}
